import Tooltip from './Tooltip';

/**
 * Help “?” control. Shows on hover (desktop) and stays usable via focus;
 * click also toggles for touch devices.
 */
export const InfoTooltip = ({
	text = 'More information',
	className = '',
	placement = 'top'
}) => (
	<Tooltip content={text} placement={placement} wrapperClassName="inline-flex shrink-0">
		<button
			type="button"
			className={`inline-flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] rounded-full border border-[#180A63] text-[#180A63] text-[10px] font-semibold leading-none cursor-help hover:bg-[#180A63]/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#180A63]/30 ${className}`}
			aria-label={text}
		>
			?
		</button>
	</Tooltip>
);
